import ga from '../utils/ga'

export const reportOpenSearchFilterPanel = (panelName) => {
  ga('send', 'event', 'Search', 'click', `open panel ${panelName}`)
}



// WEBPACK FOOTER //
// ./common/analytics/filtersAnalytics.js